import React, { useEffect } from "react";
import useApi from "../../../core/customhook/useApi";
import Loader from "../../../core/common/selfLoder";
import dayjs from "dayjs";

interface EmployeeMessage {
  ID: number;
  emp_id: string;
  employee_name: string;
  email_id: string;
  photo: string | null;
  emp_message: string;
  featured: "0" | "1";
  created_date: string;
}

interface EmployeeMessageResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: EmployeeMessage[];
}

const EmployeeSpeak: React.FC = () => {
  const {
    data: messageResponse,
    loading,
    callApi: fetchMessages,
  } = useApi<EmployeeMessageResponse>("/api/employees/message/view", {
    method: "GET",
    autoCall: false,
  });

  useEffect(() => {
    fetchMessages();
  }, []);

  return (
    <>
      <Loader loading={loading} />

      <div className="page-wrapper">
        <div className="content">
          <h2 className="mb-3">Employee Speak</h2>

          <div className="row">
            {messageResponse?.data?.map((msg) => (
              <div key={msg.ID} className="col-md-6 col-lg-4 mb-4">
                <div className="card h-100">
                  <div className="card-body d-flex flex-column gap-2">
                    {/* Header: Image + Name + Date */}
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <img
                        src={
                          msg.photo ||
                          "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                        }
                        alt={msg.employee_name}
                        className="rounded-circle"
                        width={50}
                        height={50}
                      />
                      <div>
                        <h6 className="mb-0 fw-semibold">{msg.employee_name}</h6>
                        <small className="text-muted">
                          {dayjs(msg.created_date).format("DD MMM YYYY")}
                        </small>
                      </div>
                      {msg.featured === "1" && (
                        <span className="badge bg-success ms-auto">Featured</span>
                      )}
                    </div>

                    {/* Full Message */}
                    <div
                      className="emp-message small"
                      dangerouslySetInnerHTML={{ __html: msg.emp_message }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default EmployeeSpeak;
